<template>
  <input
    :id="clientBitDumb ? 'phone-plain' : 'phone-masked'"
    :placeholder="placeholder"
    :value="phone"
    @input="onInput"
    :maxlength="clientBitDumb ? 9999 : 16"
    autocomplete="tel"
    type="text"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";
interface fakeEvent {
  target: {
    value: string;
  };
  data: string;
}
export default defineComponent({
  name: "PreviousPhoneInput",
  props: {
    placeholderPhone: String,
    phoneSet: {
      type: String,
      required: false,
      default: ""
    }
  },
  mounted() {
    if (this.phoneSet) {
      this.phone = this.phoneSet;

      const fakeEvent: fakeEvent = {
        target: {
          value: this.phone
        },
        data: this.phone
      };

      this.onInput(fakeEvent);
    }
  },
  data() {
    return {
      phone: "",
      clientBitDumb: false,
      placeholder: this.placeholderPhone || "+7 987 654-32-11"
    };
  },
  methods: {
    onInput(e: Event | fakeEvent) {
      const target = e.target as HTMLInputElement;

      const inputEvent = e as InputEvent;
      let value = target.value;
      if (isNaN(Number(inputEvent.data))) {
        target.value = value.replace(/[^0-9+\s-]/g, "");
        return;
      }
      const raw = value.replace(/\s/g, "");

      if (value === "8") {
        this.phone = "+7";
        return;
      }

      if (raw.startsWith("+78")) {
        this.clientBitDumb = true;
        this.phone = raw.replace("+78", "8");
        return;
      }

      if (raw.startsWith("+77")) {
        this.clientBitDumb = true;
        this.phone = raw.replace("+77", "7");
        return;
      }

      if (this.clientBitDumb) {
        this.phone = value;
        return;
      }

      if (!raw.startsWith("+7")) {
        const onlyDigits = raw.replace(/\D/g, "");

        if (onlyDigits.startsWith("8")) {
          value = "+7" + onlyDigits.slice(1);
        } else {
          value = "+7 " + onlyDigits;
        }
      }

      const digits = value.replace(/\D/g, "").slice(0, 11);

      if (digits[0] === "7") {
        this.phone = digits.replace(
          /^7(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/,
          (_, p1, p2, p3, p4) => {
            let result = "+7";
            if (p1) result += " " + p1;
            if (p2) result += " " + p2;
            if (p3) result += "-" + p3;
            if (p4) result += "-" + p4;
            return result;
          }
        );
      } else {
        this.phone = "+" + digits;
      }
    }
  },
  watch: {
    phone(val: string) {
      this.$emit("update:modelValue", val);
    }
  }
});
</script>
